import { render } from "./OtherContentPage.vue?vue&type=template&id=5401021f"
import script from "./OtherContentPage.vue?vue&type=script&lang=js"
export * from "./OtherContentPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/Clients/visiontrust/vision-trust-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__